export const es = {
    'buttons': {
        'return': 'Regresar'
    },
    'selects': {
        'currency': {
            'label': 'Moneda',
            'placeholder': 'Seleccione una moneda',
            'options-title': 'Lista de monedas disponibles'
        },
        'currency-and-network': {
            'placeholder': 'Seleccione una moneda y una red',
            'options-title': 'Lista de monedas disponibles'
        },
        'selected-label': 'Seleccionado: {selected} de {length}',
        'search': 'Buscar',
        'errors': {
            'invalid': 'Valor inválido',
            'required': 'Requerido',
            'card-holder': 'Ingrese el nombre y apellido del titular de la tarjeta',
            'input-amount': 'Ingrese el monto',
            'fill-card': 'Complete la información de la tarjeta'
        },
        'empty-list': 'Lista vacía',
        'address': {
            'label': 'Dirección de retiro en {currency}',
            'options-title': 'Lista de direcciones disponibles'
        },
        'cardholder-input': {
            'placeholder': 'Titular de la tarjeta'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Su dirección para el depósito'
            },
            'invoice': {
                'address': 'Dirección',
                'paid-amount': 'Monto pagado'
            }
        }
    },
    'labels': {
        'deposit': 'Depósito',
        'withdraw': 'Retiro',
        'currency': 'Moneda',
        'amount': 'Monto',
        'invoice': {
            'remaining-time': 'Tiempo restante para pagar',
            'status': {
                'expires': 'Tiempo agotado',
                'success': 'Pago exitoso',
                'error': 'Error'
            },
            'partially-paid': {
                'title': 'Parcialmente pagado',
                'info': 'El monto se ha pagado parcialmente. El monto restante debe pagarse para completar el pago.'
            },
            'orphan': {
                'title': 'Transacción huérfana',
                'description': 'Una de las transacciones de este pedido contiene una red o moneda incorrecta.',
                'contact': 'Comuníquese con soporte técnico con el ID:'
            },
            'you-paid': 'Usted pagó',
            'active-order': 'Pedido activo',
            'new-invoice': 'Nueva factura',
            'order-id': 'ID de la factura',
            'payment-amount': 'Monto del pago'
        },
        'continue': 'Continuar',
        'payout': {
            'address': 'Dirección de retiro en {currency}',
            'tag-or-memo': 'TAG o MEMO',
            'status': {
                'processed': 'Procesado',
                'error': 'Error',
                'orphan': 'Transacción huérfana',
                'approve_rejected': 'Rechazado',
                'in-progress': 'En progreso',
                'need-approve': 'Requiere aprobación',
                'awaiting-confirmation': 'Su solicitud de retiro está esperando confirmación'
            },
            'info': {
                'withdraw-id': 'ID del retiro',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Moneda y red',
                'address': 'Dirección',
                'tag-or-memo': 'TAG o MEMO',
                'amount': 'Monto del retiro'
            }
        },
        'fiat': {
            'title': 'Depósito mediante fiat',
            'info': {
                'amount': 'Monto',
                'date': 'Fecha de pago',
                'id': 'ID del depósito',
                'system': 'Sistema de pago'
            },
            'status': {
                'new': 'Nuevo',
                'pending': 'Pendiente',
                'authorized': 'Autorizado',
                'confirmed': 'Confirmado',
                'reconciled': 'Conciliado',
                'error': 'Error',
                'declined': 'Rechazado'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ID de widget incorrecto',
        'wrong-ext-user-id': 'ID de usuario externo incorrecto',
        '404': '¡Ups! Buscamos pero no encontramos lo que estás buscando.',
        'without-xt-user-id-withdrawal': 'Retiro no disponible. El parámetro extUserId no fue proporcionado',
        'without-xt-user-id-deposit': 'Depósito no disponible. El parámetro extUserId no fue proporcionado'
    },
    'invoice': {
        'order': 'Pedido',
        'inputs': {
            'email': {
                'label': 'Dirección de correo electrónico',
                'placeholder': 'Ingrese su dirección de correo electrónico'
            },
            'amount': {
                'label': 'Monto',
                'placeholder': 'Ingrese el monto'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Monto en',
                'rate': 'Tasa de cambio',
                'payment-id': 'ID del pago',
                'description': 'Descripción'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'No actualice la página ni abra la factura en una',
            'new-tab': 'nueva pestaña'
        },
        'statuses': {
            'ERROR': 'ERROR',
            'PENDING': 'PENDIENTE',
            'PROCESSED': 'PROCESADO',
            'REJECTED': 'RECHAZADO',
            'OVERPAID': 'PAGADO EN EXCESO',
            'CREATED': 'CREADO',
            'PARTIAL': 'PARCIALMENTE PAGADO',
            'INIT': 'INICIADO',
            'EXPIRED': 'EXPIRADO'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Depósito',
            'payment-history': 'Historial de pagos'
        },
        'payment-history': {
            'empty-label': 'Todas sus transacciones enviadas a la dirección indicada estarán disponibles aquí',
            'headers': {
                'date': 'Fecha y hora',
                'amount': 'Monto',
                'tx': 'Tx-Hash',
                'status': 'Estado'
            },
            'statuses': {
                'processed': 'Procesado',
                'pending': 'Pendiente',
                'rejected': 'Rechazado',
                'error': 'Error'
            },
            'in': 'en'
        },
        'qr-block': {
            'empty-label': 'Recargar con criptomonedas',
            'qr-info-pre-invoice': 'Envíe solo',
            'qr-info-pre-personal': 'Envíe cualquier cantidad solo a',
            'qr-info-post': 'en esta dirección',
            'qr-info-minimal': 'Las transferencias de menos de 1 USD no se acreditarán'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Depósito mediante fiat',
            'payment-history': 'Historial de pagos'
        },
        'labels': {
            'pay': 'Pagar',
            'service-commission': 'Monto de la comisión por servicio',
            'total': 'Total',
            'you-pay': 'Usted paga'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Transacción huérfana',
            'info': 'Una de las transacciones de este pedido contiene una red o moneda incorrecta.',
            'support': 'Comuníquese con soporte técnico con el ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Al hacer clic en el botón "Continuar", usted acepta automáticamente',
        'our': 'nuestra política de cookies'
    },
    'payout': {
        'payout': 'Pago',
        'output': 'Salida',
        'withdraw': 'Retirar',
        'errors': {
            'wrong-address': 'La dirección no pertenece a la red {network}'
        }
    }
}
